var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-brand',{attrs:{"href":_vm.cityWebsite,"target":"__blank"}},[_c('img',{staticClass:"align-top",attrs:{"id":"city_logo","src":_vm.logoLink,"alt":"Logo"}}),_vm._v(" "),_c('div',{staticClass:"align-top",attrs:{"id":"city_name"}},[_vm._v(_vm._s(_vm.cityName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174ad8ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/app-navbar-brand.vue
// module id = null
// module chunks = 